import { render, staticRenderFns } from "./OrderChip.vue?vue&type=template&id=4bbf73d8&"
import script from "./OrderChip.vue?vue&type=script&lang=ts&"
export * from "./OrderChip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports